(function ($) {
    $(document).ready(function () {
        $('.research-grid .eight-col').each(function () {
            if ($(this).find('.author-info.with-image .image').length > 0) {

                // if ($(".research-grid .column-wrapper .eight-col .card-wrapper .card-content .author-info.with-image .image").length > 0) {
                $(this).find(".author-info p").css("margin-left", "64px");
            }
        });

        $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:first-child .small-card-content h6").each(function () {
            $(this).hover(function () {
                    $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:first-child .small-card-img").addClass("zoom");
                },
                function () {
                    $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:first-child .small-card-img").removeClass("zoom");
                }
            );
        });

        $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:last-child .small-card-content h6").each(function () {
            $(this).hover(function () {
                    $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:last-child .small-card-img").addClass("zoom");
                },
                function () {
                    $(".research-grid .column-wrapper .four-col.no-border .small-card-wrapper:last-child .small-card-img").removeClass("zoom");
                }
            );
        });

        // $(".research-grid .eight-col .author-info.row-reverse").each(function () {
        //     if ($(this).hasClass(":not(.image)")) {
        //         $(this).parent().addClass('text-white');
        //     }
        // });

        $('.research-grid .column-wrapper .four-col .small-card-wrapper .small-card-content h6').each(function () {
            $(this).find('a').clone().appendTo($(this).parent().parent().find(".small-card-img"));
        });

    });

    $(window).on('load resize', function () {
        // $('.research-grid .column-wrapper .eight-col .card-wrapper').each(function () {

        //     var totalHeight = 0;
        //     var divHgt1 = $(this).find('.author-info .name-date span').height();
        //     $(this).find('.author-info .name-date').children().each(function () {
        //         totalHeight = totalHeight + $(this).outerHeight(true);
        //     });
        //     $(this).find('.author-info .name-date span').each(function () {
        //         if ($(this).html() !== '') {

        //             $(this).parent().css({'height': totalHeight});
        //         }
        //     });


        //     if ($(this).find('.author-info .name-date').height() > 22) {

        //         $(this).find('.author-info .publisher').css({'top': '-3px'});
        //     }
        //     else {
        //         $(this).find('.author-info .publisher').css({'top': '-21px'});
        //     }
        // });

        // $('.research-grid .eight-col').each(function () {
        //     if ($(this).find('.author-info.row-reverse .image.hide').length > 0) {
        //         $(this).find(".author-info .name-date").css("width", "100%");
        //     }
        // });

        // $('.research-grid .eight-col').each(function () {
        //     if ($(this).find('.hide img').length == 0) {
        //         $(this).find(".author-info .name-date").css("width", "calc(100% - 63px)");
        //     }
        // });

        // $('.featured-grid .column-wrapper .eight-col .card-wrapper').each(function () {
        //     var totalHeight = 0;
        //     var divHgt1 = $(this).find('.author-info .name-date span').height();
        //     $(this).find('.author-info .name-date').children().each(function () {
        //         totalHeight = totalHeight + $(this).outerHeight(true);
        //     });
        //     $(this).find('.author-info .name-date span').each(function () {
        //         if ($(this).html() !== '') {

        //             $(this).parent().css({'height': totalHeight});
        //         }
        //     });


        //     if ($(this).find('.author-info .name-date').height() > 22) {

        //         $(this).find('.author-info .publisher').css({'top': '-3px'});
        //     }
        //     else {
        //         $(this).find('.author-info .publisher').css({'top': '-21px'});
        //     }
        // });

    });
})(jQuery);